module.exports = __webpack_public_path__ + "img/0 (2).fc6bc28e.jpg";